import { useEffect } from "react";

const useClickOutside = (
    ref: { current: { contains: (e: EventTarget | null) => boolean } },
    callback: () => void,
    closeOnClick: boolean,
) => {
    useEffect(() => {
        const handler = (e: Event) => {
            if (!ref?.current) {
                return;
            }
            if (closeOnClick && ref.current.contains(e.target)) {
                callback();
            }
            if (!ref.current.contains(e.target)) {
                callback();
            }
        };
        document.addEventListener("mouseup", handler);
        document.addEventListener("touchstart", handler, { passive: true });
        return () => {
            document.removeEventListener("mouseup", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [ref, callback]);
};

export default useClickOutside;
